import { Converter } from '../types/converter';

export const radiationExposureConverter: Converter = {
  id: 'radiationExposure',
  name: 'Radiation Exposure Converter',
  icon: 'Radio',
  categories: ['radiology'],
  units: [
    // SI unit and prefixes
    { name: 'Coulomb/kilogram', symbol: 'C/kg', factor: 1 },
    { name: 'Millicoulomb/kilogram', symbol: 'mC/kg', factor: 0.001 },
    { name: 'Microcoulomb/kilogram', symbol: 'µC/kg', factor: 1e-6 },
    
    // Traditional units
    { name: 'Roentgen', symbol: 'R', factor: 0.000258 },
    { name: 'Tissue roentgen', symbol: 'tr', factor: 0.000258 },
    { name: 'Parker', symbol: 'parker', factor: 0.000258 },
    { name: 'Rep', symbol: 'rep', factor: 0.000258 }
  ]
};
